import { Box, FormControl, FormHelperText, InputLabel } from '@mui/material';
import { useField } from 'formik';
import { PillRadioButtonGroupContext } from './PillRadioButtonGroup.context';

export type PillRadioButtonGroupProps = {
  name: string;
  label?: React.ReactNode;
  children: React.ReactElement[];
  disabled?: boolean;
  helperText?: string;
  className?: string;
};

export const PillRadioButtonGroup: React.FC<PillRadioButtonGroupProps> = ({ name, label, disabled, children, helperText, className }) => {
  const [ field, meta, helpers ] = useField(name);

  return (
    <PillRadioButtonGroupRaw
      name={name}
      label={label}
      disabled={disabled}
      helperText={helperText}
      error={meta.touched && meta.error}
      onBlur={() => helpers.setTouched(true)}
      onClick={(value) => {
        helpers.setValue(value, true);
        helpers.setTouched(true, false);
      }}
      value={field.value}
      className={className}
    >
      {children}
    </PillRadioButtonGroupRaw>
  );
};

export type PillRadioButtonGroupRawProps = {
  onBlur?: () => void;
  onClick: (value: string | number | boolean) => void;
  value: string | number | boolean;
  error?: string | false;
} & PillRadioButtonGroupProps;

export const PillRadioButtonGroupRaw: React.FC<PillRadioButtonGroupRawProps> = (props) => {
  const hasError = Boolean(props.error);
  const helperText = props.helperText || props.error;

  return (
    <PillRadioButtonGroupContext.Provider value={{
      value: props.value,
      disabled: props.disabled ?? false,
      onClick: props.onClick,
    }}
    >
      <FormControl component="div" fullWidth error={hasError} onBlur={props.onBlur} data-field-name={props.name} className={props.className}>
        {props.label && (
          <InputLabel htmlFor={props.name} error={hasError}>
            {props.label}
          </InputLabel>
        )}
        <Box display="flex" gap="1rem" mt={1}>
          {props.children}
        </Box>
        {helperText && (
          <FormHelperText component="div" dangerouslySetInnerHTML={{ __html: helperText }} />
        )}
      </FormControl>
    </PillRadioButtonGroupContext.Provider>
  );
};
